import common from './pages/common'

const baseRouters = [
  ...common
]

export default baseRouters
